import { CONTENT_ANALYTICS } from './../config';

const reducer = (state = [], action) => {
    switch (action.type) {
        case CONTENT_ANALYTICS:
            return action.payload;
        default:
            return state;
    }
}

export default reducer;
